import { render, staticRenderFns } from "./LmSeccionEspecial.vue?vue&type=template&id=90a1feb6&"
import script from "./LmSeccionEspecial.vue?vue&type=script&lang=js&"
export * from "./LmSeccionEspecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports